@if (item) {
  @switch (item.type) {
    @case (DashboardItemType.GRAPH) {
      <app-dashboard-graph [item]="item"></app-dashboard-graph>
    }
    @case (DashboardItemType.TEXT) {
      <app-dashboard-text [item]="item"></app-dashboard-text>
    }
    @case (DashboardItemType.IMAGE) {
      <app-dashboard-image [item]="item"></app-dashboard-image>
    }
    @case (DashboardItemType.VALUE_DISPLAY) {
      <app-dashboard-value-display [item]="item"></app-dashboard-value-display>
    }
    @case (DashboardItemType.MULTI_VALUE_DISPLAY) {
      <app-dashboard-multiple-value-display [item]="item"></app-dashboard-multiple-value-display>
    }
  }
}
